const SidebarPayments = ({ width = "20", height = "13" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.375 2.875C0.375 2.14565 0.664731 1.44618 1.18046 0.930456C1.69618 0.414731 2.39565 0.125 3.125 0.125H16.875C17.6043 0.125 18.3038 0.414731 18.8195 0.930456C19.3353 1.44618 19.625 2.14565 19.625 2.875V11.125C19.625 11.8543 19.3353 12.5538 18.8195 13.0695C18.3038 13.5853 17.6043 13.875 16.875 13.875H3.125C2.39565 13.875 1.69618 13.5853 1.18046 13.0695C0.664731 12.5538 0.375 11.8543 0.375 11.125V2.875ZM18.25 2.875C18.25 2.51033 18.1051 2.16059 17.8473 1.90273C17.5894 1.64487 17.2397 1.5 16.875 1.5H3.125C2.76033 1.5 2.41059 1.64487 2.15273 1.90273C1.89487 2.16059 1.75 2.51033 1.75 2.875V4.25H18.25V2.875ZM1.75 11.125C1.75 11.4897 1.89487 11.8394 2.15273 12.0973C2.41059 12.3551 2.76033 12.5 3.125 12.5H16.875C17.2397 12.5 17.5894 12.3551 17.8473 12.0973C18.1051 11.8394 18.25 11.4897 18.25 11.125V6.3125H1.75V11.125Z"
        fill="white"
      />
    </svg>
  );
};
export default SidebarPayments;
